import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import EmailTemplateTypeStore from '../../stores/EmailTemplateTypeStore';
import EmailTemplateActions from '../../actions/EmailTemplateActionCreator';
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';

/**
 * TODO: note, the admins column is deliberately commented out for later implementation
 */
class EventNotificationSettings extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            templates: []
        };
    }

    componentDidMount() {
        this.onTemplateTypesChange = this.onTemplateTypesChange.bind(this);
        this.listener = EmailTemplateTypeStore.addListener(this.onTemplateTypesChange);
        EmailTemplateActions.getTypes({for: 'event'});
    }

    componentWillUnmount() {
        this.listener.remove();
    }

    render() {
        const tableProps = {
            selectable: false
        };

        const tableHeaderProps = {
            enableSelectAll:    false,
            displaySelectAll:   false,
            adjustForCheckbox:  false
        };

        const tableBodyProps = {
            selectable: false,
            displayRowCheckbox: false
        };

        const notifications = this.state.templates.map(template => {
            const notification = this.props.notifications.find(e => !!e && e.notification === template.internalName) || {delegate: true, creator: false, admins: false};
            return {
                ...template,
                ...notification
            };
        });

        return (
            <Table {...tableProps}>
                <TableHeader {...tableHeaderProps}>
                    <TableRow>
                        <TableHeaderColumn>Notification</TableHeaderColumn>
                        <TableHeaderColumn>Delegate</TableHeaderColumn>
                        <TableHeaderColumn>Creator</TableHeaderColumn>
                        <TableHeaderColumn>Managers</TableHeaderColumn>
                        {/*<TableHeaderColumn>Admins</TableHeaderColumn>*/}
                    </TableRow>
                </TableHeader>
                <TableBody {...tableBodyProps}>
                    {notifications.map(notification => (
                        <TableRow key={notification.id}>
                            <TableRowColumn>{notification.name}</TableRowColumn>
                            <TableRowColumn>
                                <Checkbox
                                    name={`notifications[${notification.internalName}][delegate]`}
                                    value={notification.delegate}
                                    onChange={this.onCheckboxChange.bind(this, notification.id, 'delegate')}
                                />
                            </TableRowColumn>
                            <TableRowColumn>
                                <Checkbox
                                    name={`notifications[${notification.internalName}][creator]`}
                                    value={notification.creator}
                                    onChange={this.onCheckboxChange.bind(this, notification.id, 'creator')}
                                />
                            </TableRowColumn>
                            <TableRowColumn>
                                <Checkbox
                                    name={`notifications[${notification.internalName}][managers]`}
                                    value={notification.managers}
                                    onChange={this.onCheckboxChange.bind(this, notification.id, 'managers')}
                                />
                            </TableRowColumn>
                            {/*<TableRowColumn>
                                <Checkbox
                                    name={`notifications[${notification.internalName}][admins]`}
                                    value={notification.admins}
                                    onChange={this.onCheckboxChange.bind(this, notification.id, 'admins')}
                                />
                            </TableRowColumn>*/}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    onTemplateTypesChange() {
        const templates = EmailTemplateTypeStore.getFor('event');
        if (templates !== undefined && templates.length > 0) {
            this.setState({templates});
        }
    }

    onCheckboxChange(id, recipient, event, value) {
        if (!!this.props.onChange) {
            this.props.onChange(id, recipient, value);
        }
    }
}

EventNotificationSettings.propTypes = {
    notifications:  PropTypes.arrayOf(
        PropTypes.shape({
            notification:   PropTypes.string.isRequired,
            delegate:       PropTypes.bool,
            creator:        PropTypes.bool,
            managers:       PropTypes.bool,
            admins:         PropTypes.bool,
        })
    ),
    onChange:       PropTypes.func
};

EventNotificationSettings.defaultProps = () => ({});

export default EventNotificationSettings;
